<template>
  <div class="about">
    <img
      src="@/assets/yellow-dashes.webp"
      alt="yellow dashes"
      class="dashes-mobile"
    />
    <img
      src="@/assets/pink-eclipse.webp"
      alt="a pink eclipse"
      class="pink-eclipse"
    />
    <h3 class="header">About</h3>
    <p class="header-brief">
      Partnering with diverse organisations from charities to wellness brands to
      tech innovators to deliver measurable impact.
    </p>
    <div class="flex">
      <div class="left">
        <img
          src="@/assets/LydiaWithClient.webp"
          alt="Lydia Turner"
          class="lydia"
        />
        <img
          src="@/assets/yellow-dashes.webp"
          alt="yellow dashes"
          class="yellowDashes"
        />
      </div>
      <div class="right">
        <span>{{ yearsExperience }}</span>
        <p class="sub-heading">Digital marketer & PR manager</p>
        <p class="info">{{ info }}</p>
        <p class="info">{{ moreInfo }}</p>
        <a class="contact-btn" @click="handleClick('contact')">Contact me</a>
      </div>
    </div>
    <img
      src="@/assets/green-eclipse.webp"
      alt="a green eclipse"
      class="green-eclipse"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: "Based in Sheffield, I began my career in digital marketing after earning a degree in Journalism and have since built over 5 years of experience creating and delivering tailored digital strategies. Alongside multiple digital marketing certifications, I’ve worked with more than 15 organisation, ranging from charities and not-for-profits to businesses generating over £250K annually, helping them strengthen their online presence and achieve measurable growth.",
      moreInfo:
        "My expertise spans the full spectrum of modern digital marketing, including CRM systems, automation, email marketing, social media management, paid advertising, content creation, and website redevelopment. Whether it’s building a brand voice, enhancing customer engagement, or optimising campaigns for ROI, I approach every project with a strategic mindset and a focus on long-term impact. I am committed to understanding each client’s unique culture and audience, ensuring every strategy not only aligns with business objectives but also delivers meaningful results.",
    };
  },
  methods: {
    handleClick(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },
  },

  computed: {
    yearsExperience() {
      return `${new Date().getFullYear() - 2020}+ Years Experience`;
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  position: relative;
  overflow-x: hidden;
}

h3 {
  font-size: 50px;
  font-weight: 700;
  color: white;
  text-align: center;
}

.dashes-mobile {
  position: absolute;
  display: none;
  top: -50px;
  right: -50px;
  z-index: -1;
  transform: rotate(355deg);
  width: 40%;
}

.pink-eclipse {
  position: absolute;
  top: 20px;
  width: 20px;
}

.green-eclipse {
  position: absolute;
  right: 10%;
  bottom: 50px;
  width: 35px;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 150px 50px 150px;
  position: relative;
  margin: 0 auto;
}

.left {
  position: relative;
}

.left,
.right {
  @media (max-width: 480px) {
    width: 100%;
    padding: 0;
  }

  width: 50%;
  margin-left: 50px;

  span {
    color: #258675;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
  }

  .sub-heading {
    font-weight: 600;
    font-size: 25px;
    color: #1c0a0a;
  }

  .info {
    overflow-y: scroll;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #584f49;
    padding-bottom: 5px;
  }

  a {
    color: white;
    background: #ff9f66;
    border-radius: 4px;
    border: none;
    padding: 10px 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #e9905d;
    }
  }
}

.lydia {
  max-width: 100%;
  min-width: 300px;
  height: auto;
}

.yellowDashes {
  top: -70px;
  left: -120px;
  position: absolute;
  z-index: -1;
}

.header {
  text-align: center;
  color: #1c0a0a;
  font-size: 50px;
  font-weight: 700;
  line-height: 60px;
  margin-bottom: 20px;

  &-brief {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #584f49;
    width: 50%;
    margin: 0 auto;
  }
}

@media (max-width: 1050px) {
  .flex {
    padding: 50px 50px 50px 50px;
  }
}

@media (max-width: 768px) {
  .flex {
    flex-direction: column;
    padding: 50px 0 50px 0;
    margin: 0;
    width: 100%;
  }

  .yellowDashes {
    display: none;
  }

  .dashes-mobile {
    display: block;
  }

  .left,
  .right {
    @media (max-width: 480px) {
      padding: 15px 20px;
    }
    width: auto;
    margin: 0;
    padding: 20px 70px;
  }

  .header-brief {
    width: 80%;
    margin: 0 auto;
  }

  .right {
    span {
      color: #258675;
      line-height: 0;
    }

    .sub-heading {
      line-height: 40px;
      padding: 0;
    }
  }
}
</style>
